import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/sections/HomeClient.tsx");
